import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { RECENTLY_SUBSCRIBED_NEWSLETTERS_KEY } from "scmp-app/scmp-sdk/components/newsletter/newsletter-widget/hooks";

import { accountAtom } from "shared/lib/account";

export const useLoginCleanupEffect = () => {
  const { isLoggedIn } = useAtomValue(accountAtom);
  const [isClear, setIsClear] = useState(false);

  useEffect(() => {
    if (!isLoggedIn || isClear) return;
    sessionStorage.removeItem(RECENTLY_SUBSCRIBED_NEWSLETTERS_KEY);
    setIsClear(true);
  }, [isClear, isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) return;
    setIsClear(false);
  }, [isLoggedIn]);
};
